import React from "react"
import styled from "styled-components"

const Holder = styled.div`
  width: 100%;
  height: var(--windowHeight);
  overflow: hidden;
  background: linear-gradient(180deg, #ff9d9d 0%, #f5e2af 100%);
`

function CanvasHolder({ children }) {
  return <Holder>{children}</Holder>
}

export default CanvasHolder
